var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Header',{attrs:{"menu":_vm.menu}}),_c('v-content',[_c('router-view',{on:{"update":_vm.actualizar}})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }